/**
 * Serviço de comunicação com a API REST do IBGE, para obtenção de dados de CNAE. 
 */

angular.module("avlib").factory("avCnaeService", ["$log", "$http", "$q", function ($log, $http, $q){

	/*
	 * Constante arbitrária para sinalizar erro por CEP inválido.
	 */
	var _INVALID_CNAE_ERROR = 9832;
	
	/**
	 * Cache contendo como chave o um CNAE e como valor associado o objeto com dados da atividade daquele CNAE
	 */
	/*
	 * A cache foi adicionada para, além de agilizar a consulta por CNAE, reduzir a pressão sobre o serviço do IBGE.
	 */
	var cnaeCache = new LruMap({}, 50);
	
	/**
	 * Obtém dados de endereço a partir do CEP informado.
	 */
	var _getActivityByCnae = function(cnae){
		
		var cnaeDeferred = $q.defer();
		
		if (cnae != null){
			cnae = cnae.replace(/[^0-9]/g,"");
		}
		
		var cachedCnae = cnaeCache.get(cnae);
		
		if (cachedCnae == _INVALID_CNAE_ERROR){
			$log.debug("Foi informado um CNAE inválido (via cache).");
			var reason = {textStatus: "Foi informado um CNAE inválido.", error: _INVALID_CNAE_ERROR}
			cnaeDeferred.reject(reason);
		}else if (cachedCnae != null){
			$log.debug("Dados obtidos com sucesso a partir da cache.");
			cnaeDeferred.resolve(cachedCnae);
		}else{
			$http.get('https://servicodados.ibge.gov.br/api/v2/cnae/subclasses/'+cnae).then(function(response){
				/*
				 * A documentação da API versão 2 do IBGE informa sobre o retorno a essa chamada:
				 * Status: 200 - Um objeto - Caso apenas um identificador seja informado - ou um array de subclasses
				 * 
				 * Apesar de estarmos utilizando um único identificador de CNAE na chamada, observamos que
				 * o serviço retornava sempre um array de objetos. Cada um dos objetos continha o mesmo CNAE
				 * e basicamente os mesmos dados, exceto a descrição das atividades. Aparentemente algum tipo
				 * solução de contorno para reunir descrições de atividades distintas sobre um mesmo código CNAE.
				 *
				 * Feita essa constatação, preparamos o nosso algoritmo para selecionar o primeiro objeto do array,
				 * ignorando as demais ocorrência. Até que em fevereiro de 2020, o cliente Contabilidade Nogueira
				 * reportou um problema no seu sistema (ver tarefa Mantis 670). Para o CNAE válido 4691-5/00, o
				 * serviço estava retornando um único objeto, comprometendo nossa implementação. Para solucionar
				 * o caso, passamos então a testar se o serviço retornou um objeto ou um array.
				 */
				if (response.data && (!Array.isArray(response.data) || response.data.length > 0)){
					$log.debug("Dados obtidos com sucesso a partir do servidor.");
					var ibgeData = Array.isArray(response.data) ? response.data[0]: response.data;
					var data = {
						id: ibgeData.id,
						descricao: ibgeData.descricao,
					};
					cnaeCache.set(cnae, data);
					cnaeDeferred.resolve(data);
				}else{
					$log.debug("Foi informado um CNAE inválido.");
					var reason = {statusText: "Foi informado um CNAE inválido.", status: _INVALID_CNAE_ERROR};
					cnaeDeferred.reject(reason);	
				}
			}, function(response){
				$log.debug("Falha no acesso ao servidor do CNAE: "+response.status+" "+response.statusText);
				cnaeDeferred.reject(response);
			});
		}
		
		return cnaeDeferred.promise;
	};
	
	return {
		INVALID_CNAE_ERROR: _INVALID_CNAE_ERROR,
		getActivityByCnae: _getActivityByCnae,
	};
}]);
